import React from 'react';
import { useMutation } from '@apollo/client';
import TriggerSyncMutation from './TriggerSyncMutation';
import WearableConnectionsQuery from '../Fetch/WearableConnectionsQuery';
import type { WearableMutationResult } from '../DisconnectWearable/DisconnectWearableConnectorApollo';

interface Result {
  triggerSync: (providerKey: string) => Promise<WearableMutationResult>;
  loading: boolean;
}

interface Props {
  children: (result: Result) => React.ReactElement;
}

const TriggerSyncConnectorApollo: React.FC<Props> = ({ children }) => {
  const [mutate, { loading }] = useMutation(TriggerSyncMutation, {
    refetchQueries: [{ query: WearableConnectionsQuery }],
    awaitRefetchQueries: true,
  });

  const triggerSync = async (providerKey: string): Promise<WearableMutationResult> => {
    try {
      const response = await mutate({ variables: { provider: providerKey } });
      const payload = response.data?.wearable?.triggerSync;

      if (payload?.__typename === 'BasicMutationSuccess') {
        return { ok: true };
      }

      const message =
        payload?.description || payload?.name || payload?.code || 'wearable_sync_error';
      return { ok: false, reason: 'server', message };
    } catch (error) {
      const message = error instanceof Error ? error.message : 'wearable_sync_network_error';
      return { ok: false, reason: 'network', message };
    }
  };

  return children({ triggerSync, loading });
};

export default TriggerSyncConnectorApollo;
